import { Alert, AlertDescription, AlertTitle } from '#app/components/ui/alert'
import { Icon } from '#app/components/ui/icon.js'

export function AlertError({ message }: { message: string }) {
	return (
		<Alert className="mb-4" variant="destructive">
			<Icon name="exclamation-triangle" className="h-4 w-4" />
			<AlertTitle>Error</AlertTitle>
			<AlertDescription>{message}</AlertDescription>
		</Alert>
	)
}
